import { render, staticRenderFns } from "./TranTypeHelpListNew.vue?vue&type=template&id=616eb5f8&"
import script from "./TranTypeHelpListNew.vue?vue&type=script&lang=js&"
export * from "./TranTypeHelpListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports